export class AnalyticsEventEmitter {
  posthog

  constructor(posthogInstance) {
    this.posthog = posthogInstance
  }

  /**
   * Captures and emits an analytics event with user and client information
   * @param {Object} params - The event parameters
   * @param {string} params.eventName - The name of the event to be captured
   * @param {string} params.userId - The unique identifier of the user
   * @param {string} params.clientName - The name of the client/company
   * @param {string} [params.campaignId] - The unique identifier of the campaign (optional)
   * @param {Object} [params.additionalPayload={}] - Optional additional data to include in the event
   * @returns {void}
   */
  run({ eventName, userId, clientName, campaignId, additionalPayload = {} }) {
    try {
      if (!this.posthog) {
        console.warn('PostHog instance not initialized.')
        return
      }

      if (!userId || !clientName || !eventName) {
        console.warn('Missing parameter on event payload.')
        return
      }

      const basePayload = {
        userId,
        companyName: clientName,
      }

      if (campaignId) {
        basePayload.campaignId = campaignId
      }

      const payload = { ...basePayload, ...additionalPayload }
      this.posthog.capture(eventName, payload)
    } catch (error) {
      console.error('Error capturing analytics event:', error)
    }
  }
}
